<template>
  <div class="mainCainter">
    <van-popup round :close-on-click-overlay="false" v-model="gobackIf">
      <div class="moduleMian">
        <div class="tittle">小提示</div>
        <div class="tip">
          <span>您即将错过一大波优惠，</span>
          <span>确认不考虑领取吗？</span>
        </div>
        <div class="btnBoxs">
          <div class="goback" @click="goback">去意已决</div>
          <div class="close" @click="close">再考虑一下</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: ["gobackIf", "params"],
  data() {
    return {
      gobackIfshow: false,
      paramsData: {},
    };
  },
  watch: {
    gobackIf: {
      //深度监听，可监听到对象、数组的变化
      handler(val) {
        this.gobackIfshow = val;
      },
      deep: true, //true 深度监听
    },
    params: {
      handler(val) {
        this.paramsData = val;
      },
      deep: true, //true 深度监听
    },
  },
  mounted() {
    this.gobackIfshow = this.gobackIf;
  },
  methods: {
    //分享弹窗关闭
    close() {
      this.gobackIfshow = false;
      this.$emit("closeGoback", false);
    },
    goback() {
       this.$emit("getGoback"); 
    },
  },
};
</script>
<style lang="less" scoped>
.mainCainter {
  .van-popup {
    width: 80%;
  }
  .moduleMian {
    .tittle {
      font-size: 20px;
      text-align: center;
      font-weight: bold;
      color: #df602f;
      line-height: 50px;
    }
    .tip {
      font-size: 16px;
      font-weight: bold;
      color: #e77a50;
      line-height: 22px;
      margin: 10px;
      span {
        text-align: center;
        display: block;
      }
    }
    .btnBoxs {
      width: 90%;
      margin: 0 auto 20px;
      padding-top: 10px;
      display: flex;
      justify-content: space-between;
      div {
        width: 48%;
        height: 44px;
        line-height: 44px;
        text-align: center;
        font-weight: 900;
      }
      .goback {
        background: rgba(255, 158, 150, 0.5);
        box-shadow: 0px 2px 5px 0px rgba(255, 158, 150, 0.5);
        border-radius: 48px;
        color: #ef5750;
      }
      .close {
        background: linear-gradient(
          180deg,
          #ffdf88 0%,
          #ff8e64 10%,
          #fe0602 100%
        );
        box-shadow: 0px 2px 5px 0px #ff9e96;
        color: #fff;
        border-radius: 48px;
      }
    }
  }
}
</style>
